import { render, staticRenderFns } from "./InspectionSection.vue?vue&type=template&id=b204cf4a&scoped=true"
import script from "./InspectionSection.vue?vue&type=script&lang=js"
export * from "./InspectionSection.vue?vue&type=script&lang=js"
import style0 from "./InspectionSection.vue?vue&type=style&index=0&id=b204cf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b204cf4a",
  null
  
)

export default component.exports